// RoomTypeTable.js

import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Input,
} from "reactstrap";
import {
  FaEdit,
  FaTrash,
  FaEye,
} from "react-icons/fa";

import TableContainer from "../../../../Components/Common/TableContainer";

const RoomTypeTable = ({
  data = [],
  search,
  setSearch,
  onSelect,
  onEdit,
  onDelete,
  onAdd,
}) => {
  const columns = [
    {
      header: "Room Type ID",
      accessorKey: "_id",
      cell: ({ row }) => (
        <span
          onClick={() => onSelect(row.original)}
          style={{
            color: "#0d6efd",
            cursor: "pointer",
            fontWeight: 600,
            textDecoration: "underline",
          }}
        >
          {row.original._id?.slice(-8)}
        </span>
      ),
    },

    {
      header: "Created Date",
      accessorKey: "createdAt",
      cell: ({ row }) => (
        <span>
          {new Date(
            row.original.createdAt
          ).toLocaleDateString("en-IN")}
        </span>
      ),
    },

    {
      header: "Name",
      accessorKey: "name",
    },

    {
      header: "Code",
      accessorKey: "code",
    },

    {
      header: "Base Price",
      accessorKey: "basePrice",
      cell: ({ row }) => (
        <span>
          ₹
          {Number(
            row.original.basePrice || 0
          ).toLocaleString()}
        </span>
      ),
    },

    {
      header: "Inventory",
      accessorKey: "inventory",
      cell: ({ row }) => (
        <span className="fw-semibold">
          {row.original.inventory}
        </span>
      ),
    },

    {
      header: "Action",
      cell: ({ row }) => (
        <div className="d-flex gap-2">
          {/* View */}
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-soft-primary"
              onClick={() =>
                onEdit(row.original)
              }
            >
              <i className="ri-edit-line"></i>
            </button>

            <button
              className="btn btn-sm btn-soft-danger"
              onClick={() =>
                onDelete(row.original._id)
              }
            >
              <i className="las la-trash-alt"></i>
            </button>
          </div>

        </div>
      ),
    },
  ];

  return (
    <Card
      className=" border-1"
      style={{
        borderRadius: "8px",
      }}
    >
      {/* =========================
          HEADER
      ========================= */}

      <CardBody>
        <TableContainer
          columns={columns}
          data={data}
          tableClass="align-middle table-nowrap mb-0"
          theadClass="table-light"
          divClass="table-responsive"
        />
      </CardBody>
    </Card>
  );
};

export default RoomTypeTable;